<a *ngIf="linkToProfile && userPublic?.uid" [routerLink]="['/social','user',userPublic?.uid]">
    <img [class]="cssClass" [src]="userPublic?.imgUrlThumb" [style.border-radius.px]="circle?1000:0"
         [style.height.px]="height?height:size" [style.width.px]="width?width:size"
         alt="User avatar"
         class="user-img" default="./assets/images/default/default-user-w300.webp" i18n="user avatar" style="object-fit: contain;"/>
</a>
<img *ngIf="!(linkToProfile && userPublic?.uid)" [class]="cssClass" [src]="userPublic?.imgUrlThumb" [style.border-radius.px]="circle?1000:0"
     [style.height.px]="height?height:size" [style.width.px]="width?width:size" alt="User avatar"
     class="user-img" default="./assets/images/default/default-user-w300.webp" i18n="user avatar" style="object-fit: contain;"/>
